const locale = {
    search : '検索',
    logo:'ロゴ',
    company_logo:'追加 ロゴ',
    members:'メンバー',
    status:'ステータス',
    actions:'オプション',
    multiple_companies: '企業',
    head_admin_list:'管理者リスト',
    add_company: '追加',
    details:'詳細',
    delete_company:'削除',
    activate_company:'有効にする', 
    active:'有効',
    activate:'有効にする',
    inactive:'無効',
    company_details: '詳細',
    company_id: '企業 ID',
    company_name: '会社名',
    domain: 'ドメイン',
    location: '位置',
    enter_company_id: '企業 ID',
    enter_company_name: '会社名',
    enter_domain: 'ドメイン',
    enter_location: '位置',
    add_head_admin: '追加 管理者',
    head_admin: '管理者',
    name:'名前',
    email:'メール',
    enter_name:'名前',
    enter_email:'メール',
    please_write_down_the_name_of_the_company_before_action: '企業名を入力してください',
    edit_headAdmin: "編集 管理者",
    delete_headAdmin: "削除 管理者",
    please_write_down_the_name_of_the_headAdmin_before_action: '管理者を入力してください',
    company_logo_here: 'Company logo here',
    do_you_want_to_activate_this_company:'有効にしますか?',
    do_you_want_to_delete_this_company:'削除しますか？',
    filter:'フィルタ',
    filter_by:'フィルタ:',
    reset_filters:'フィルタをリセット',
    account_status: 'アカウント',
    cancel:'キャンセル',
	delete:'削除',
	submit:'登録',
	update:'更新',
    no_matching_records_found: 'テーブル内のデータなし',
    please_enter_a_valid_domain:'有効なドメインを入力してください',
    something_went_wrong: 'エラー!',
    update_succesfully: '更新完了!',
    removed_succesfully:'削除完了!',
    do_you_want_to_delete_this_head_admin:'削除しますか？',
    head_admin_added_succesfully:'管理者の更新完了',
    loading:'読み込み中...',   
    this_email_already_exist:'このEメールは既に存在します!',
    this_name_already_exist: 'この名前は既に存在します!',
    this_domain_already_exist:'このドメインは既に存在します!',
    company_created_succesfully: '企業作成完了!',
    please_create_head_admin:'管理者追加してください',
    edit_company: '編集',
    dashboard:'Dashboard',
    connect: 'Connect',
    live_streaming:'Live Streaming',
    mix_calendar:'Mix Calendar',
    contacts: 'Contacts',
    project_map:'Project Map',
    cctv_map: 'CCTV Map',
    choose_services:'サービス',
    assign_head_admin: '追加 管理者',
    choose_services_for_menu_sidebar: 'Choose services for menu sidebar',
    please_setup_wich_services_you_want_for_the_company_by_clicking_the_available_checkboxes: 'Please setup which services you want for the Company by clicking the available checkboxes.',
};

export default locale;